"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecp256k1Instance = exports.setSecp256k1Instance = void 0;
const secp256k1_1 = __importDefault(require("secp256k1"));
// default uses node.js's secp256k1
let impl = {
    publicKeyTweakAdd: (publicKey, tweak) => Promise.resolve(secp256k1_1.default.publicKeyTweakAdd(publicKey, tweak)),
};
/**
 * allows to override the default Secp256k1Instance
 */
function setSecp256k1Instance(override) {
    impl = override;
}
exports.setSecp256k1Instance = setSecp256k1Instance;
/**
 * get the current Secp256k1Instance
 */
function getSecp256k1Instance() {
    return impl;
}
exports.getSecp256k1Instance = getSecp256k1Instance;
//# sourceMappingURL=secp256k1.js.map